import MESSAGES from 'core/data-model/constants/bi-messages'
import { bankOptions, getBankData } from '../components/bank-options'
import { buildColumn } from 'core/service/pdf-generation/utils/builder'

const LIST_LEFT_MARGIN = 20
const header = {
  marginBottom: 5,
  bold: true,
}

export const _paymentChannelsSubSection = (paymentLabel, bankOptionsSection) => [
  { text: MESSAGES.PAYMENT_TERMS },
  {
    margin: [LIST_LEFT_MARGIN, 10, 0, 0],
    ul: [
      {
        stack: [
          { text: MESSAGES.PAYMENT_BANK_COUNTER, bold: true },
          { text: MESSAGES.PAYMENT_BANK_COUNTER_TERMS },
          bankOptionsSection,
        ],
      },
      { marginTop: 10, stack: [{ text: paymentLabel, bold: true }, { text: MESSAGES.PAYMENT_AGENT_OR_BANK_TERMS }] },
      {
        marginTop: 7,
        stack: [{ text: MESSAGES.PAYMENT_COMPANY, bold: true }, { text: MESSAGES.PAYMENT_COMPANY_TERMS }],
      },
    ],
  },
  {
    text: MESSAGES.PAYMENT_TYPES,
    style: header,
    marginTop: 15,
  },
  {
    marginLeft: LIST_LEFT_MARGIN,
    ul: [
      { text: MESSAGES.PAYMENT_TYPES_CASH, bold: true },
      {
        stack: [{ text: MESSAGES.PAYMENT_TYPES_ATM, bold: true }, { text: MESSAGES.PAYMENT_TYPES_ATM_TERMS }],
      },
      {
        stack: [
          { text: MESSAGES.PAYMENT_TYPES_INTERNET_BANK, bold: true },
          { text: MESSAGES.PAYMENT_TYPES_INTERNET_BANK_TERMS },
        ],
      },
    ],
  },
  {
    text: MESSAGES.PAYMENT_FEE,
    style: header,
    marginTop: 15,
  },
  {
    text: MESSAGES.PAYMENT_FREE_OF_CHARGE,
  },
]

export const paymentChannelsSubSection = async ({ paymentLabel }) => {
  const bankOptionsSection = await bankOptions()
  return _paymentChannelsSubSection(paymentLabel, bankOptionsSection)
}

export const paymentChannelsSectionILink = () => {
  const bankData = getBankData()
  return _paymentChannelsSectionILink(bankData)
}

export const _paymentChannelsSectionILink = (bankData) => {
  return [
    {
      bold: true,
      text: 'หมายเหตุ',
    },
    {
      marginLeft: 10,
      text:
        'เพื่อให้กรมธรรม์ประกันชีวิตมีผลคุ้มครองโดยสมบูรณ์และผู้เอาประกันภัยได้รับประโยชน์สูงสุด ผู้เอาประกันภัยมีหน้าที่ในการนำส่งเบี้ยประกันภัย ซึ่งตัวแทน, นายหน้าประกันชีวิต,',
    },
    {
      text:
        ' ลูกจ้าง, หรือพนักงานบริษัท มาเก็บเบี้ยประกันภัยเป็นการให้บริการเท่านั้น โดยบริษัทฯ ได้อำนวยความสะดวกในการชำระเบี้ยประกันภัย ผ่านช่องทางต่าง ๆ ดังนี้',
    },
    {
      ol: [
        [
          'ชำระผ่านเคาน์เตอร์ธนาคารกรุงไทย เป็นเงินสด หรือตั๋วแลกเงิน หรือแคชเชียร์เช็ค หรือเช็คสั่งจ่าย “บริษัท กรุงไทย-แอกซ่า ประกันชีวิต จำกัด (มหาชน)”',
          'โดยผู้เอาประกันภัยจะได้รับใบรับเงินชั่วคราวงวดแรกทันที หลังจากชำระเงินค่าเบี้ยประกันภัย และใบรับเงินชั่วคราวดังกล่าวจะต้องไม่หมดอายุ',
        ],
        [
          'ชำระผ่านแผนกรับชำระเบี้ย ณ ที่ทำการสาขา หรือที่สำนักงานใหญ่ของบริษัทฯ เป็นเงินสด โดยกรณีชำระเป็นเงินสดชำระได้ไม่เกิน 30,000 บาท หรือตั๋วแลกเงิน หรือแคชเชียร์เช็ค หรือเช็คสั่งจ่าย “บริษัท กรุงไทย-แอกซ่า ประกันชีวิต จำกัด (มหาชน)” หรือบัตรเครดิต',
        ],
        [
          'ชำระผ่านเคาน์เตอร์ของธนาคารกรุงไทย ธนาคารกรุงเทพ ธนาคารกรุงศรีอยุธยา ธนาคารกสิกรไทย ธนาคารเพื่อการเกษตรและสหกรณ์การเกษตร ทุกสาขา',
          'ทั่วประเทศไทยผ่านระบบ Bill payment โดยระบุชื่อบัญชี “บริษัท กรุงไทย-แอกซ่า ประกันชีวิต จำกัด (มหาชน)” และแจ้ง Comp. Code หรือ Service Code  โดยใช้แบบฟอร์มใบนำฝากของธนาคาร,',
          '“ใบรับชำระค่าสาธารณูปโภคและค่าบริการ”',
          {
            text: 'ชำระผ่านระบบ Bill payment',
          },
          {
            columns: buildColumn([
              {
                label: '',
                value: `${bankData.byBill[0][0]}`,
                width: '20%',
                bold: false,
              },
              {
                label: '',
                value: `${bankData.byBill[0][1]}`,
                width: '30%',
                bold: false,
              },
              {
                label: '',
                value: `${bankData.byBill[1][0]}`,
                width: '25%',
                bold: false,
              },
              {
                label: '',
                value: `${bankData.byBill[1][1]}`,
                width: '25%',
                bold: false,
              },
            ]),
          },
          {
            columns: buildColumn([
              {
                label: '',
                value: `${bankData.byBill[2][0]}`,
                width: '20%',
                bold: false,
              },
              {
                label: '',
                value: `${bankData.byBill[2][1]}`,
                width: '30%',
                bold: false,
              },
              {
                label: '',
                value: `${bankData.byBill[3][0]}`,
                width: '25%',
                bold: false,
              },
              {
                label: '',
                value: `${bankData.byBill[3][1]}`,
                width: '25%',
                bold: false,
              },
            ]),
          },
          {
            columns: buildColumn([
              {
                label: '',
                value: `${bankData.byBill[4][0]}`,
                width: '20%',
                bold: false,
              },
              {
                label: '',
                value: `${bankData.byBill[4][1]}`,
                width: '30%',
                bold: false,
              },
            ]),
          },
        ],
        [
          'ชำระโดยการโอนเงินผ่านตู้ ATM ของธนาคารกรุงไทย ธนาคารกรุงเทพ ธนาคารกรุงศรีอยุธยา ธนาคารไทยพาณิชย์ ธนาคารกสิกรไทย ธนาคารทหารไทยธนชาต ทั่วประเทศ',
          {
            columns: buildColumn([
              {
                label: '',
                value: `${bankData.byATM[0][0]}`,
                width: '20%',
                bold: false,
              },
              {
                label: '',
                value: `${bankData.byATM[0][1]}`,
                width: '30%',
                bold: false,
              },
              {
                label: '',
                value: `${bankData.byATM[1][0]}`,
                width: '25%',
                bold: false,
              },
              {
                label: '',
                value: `${bankData.byATM[1][1]}`,
                width: '25%',
                bold: false,
              },
            ]),
          },
          {
            columns: buildColumn([
              {
                label: '',
                value: `${bankData.byATM[2][0]}`,
                width: '20%',
                bold: false,
              },
              {
                label: '',
                value: `${bankData.byATM[2][1]}`,
                width: '30%',
                bold: false,
              },
              {
                label: '',
                value: `${bankData.byATM[3][0]}`,
                width: '25%',
                bold: false,
              },
              {
                label: '',
                value: `${bankData.byATM[3][1]}`,
                width: '25%',
                bold: false,
              },
            ]),
          },
          {
            columns: buildColumn([
              {
                label: '',
                value: `${bankData.byATM[4][0]}`,
                width: '20%',
                bold: false,
              },
              {
                label: '',
                value: `${bankData.byATM[4][1]}`,
                width: '30%',
                bold: false,
              },
              {
                label: '',
                value: `${bankData.byATM[5][0]}`,
                width: '25%',
                bold: false,
              },
              {
                label: '',
                value: `${bankData.byATM[5][1]}`,
                width: '25%',
                bold: false,
              },
            ]),
          },
        ],
        [
          'ชำระโดยการโอนเงินผ่านโมบายแอปพลิเคชันของธนาคารกรุงไทย ธนาคารกรุงเทพ ธนาคารกรุงศรีอยุธยา ธนาคารไทยพาณิชย์ ธนาคารกสิกรไทย ธนาคารทหารไทยธนชาต  อ้างอิง Comp. Code หรือ รหัสบริษัท ตามข้อ 4',
        ],
        [
          'ชำระโดยการโอนเงินผ่านอินเตอร์เน็ตแบงกิ้งของธนาคารกรุงเทพ ธนาคารกรุงศรีอยุธยา และ ธนาคารกสิกรไทย อ้างอิง Comp. Code หรือ รหัสบริษัท ตามข้อ 3 และ 4',
        ],
        [
          'บริการพิเศษ สำหรับการชำระเบี้ยประกันภัยในงวดถัดไป สามารถชำระโดยสมัครหักค่าเบี้ยประกันอัตโนมัติผ่านบัญชีธนาคารประเภทออมทรัพย์หรือกระแสรายวัน ผ่านธนาคารกรุงไทย ธนาคารกรุงเทพ ธนาคารกรุงศรีอยุธยา ธนาคารกสิกรไทย ธนาคารไทยพาณิชย์ ทุกสาขาทั่วประเทศ โดยสามารถสมัครผ่าน Emma Application (เฉพาะธนาคารกรุงไทยเท่านั้น) หรือ ช่องทาง eChannel (ATM, Website หรือ Moblie Application ของธนาคาร) หรือ กรอกหนังสือยินยอมหักค่าเบี้ยประกันอัตโนมัติผ่านบัญชีธนาคาร พร้อมแนบสำเนาสมุดบัญชีเงินฝากธนาคารหน้าแรก และสำเนาบัตรประจำตัวประชาชนของเจ้าของบัญชีมาด้วยในการสมัครทุกครั้ง ทั้งนี้เบี้ยประกันภัยงวดแรกจะไม่สามารถชำระโดยการหักค่าเบี้ยประกันอัตโนมัติผ่านบัญชีธนาคารได้',
        ],
        [
          'บริการพิเศษ สำหรับการชำระเบี้ยประกันภัยในงวดถัดไป สามารถชำระโดยหักบัตรเครดิตอัตโนมัติ ประเภท VISA หรือ MASTER หรือ JCB โดยลูกค้าสามารถขอลิงก์',
          'เพื่อสมัครบริการหักค่าเบี้ยประกันภัยอัตโนมัติได้ทาง ศูนย์ลูกค้าสัมพันธ์ โทร 1159 ศูนย์บริการครบวงจร (One Stop Service) สำนักงานใหญ่ สำนักงานสาขาของบริษัทฯ Emma Application หรือขอลิงก์ผ่านระบบ Advisor Zone หรือ eSolutions ในขั้นตอนสมัครกรมธรรม์ โดยลูกค้าจะได้รับ QR Code ผ่านช่องทางอีเมลที่ท่านให้ไว้กับทางบริษัทฯ ทั้งนี้เบี้ยประกันภัยงวดแรกจะไม่สามารถชำระโดยการหักค่าเบี้ยประกันอัตโนมัติด้วยบัตรเครดิตได้',
        ],
      ],
    },
  ]
}
